import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

export const useLogClickChangePassword = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();

  return useCallback(() => {
    logAnalyticsEvent({
      name: 'CLICK_CHANGE_PASSWORD',
      channel: ['firebase', 'amplitude', 'ablylog'],
      analytics: {
        SCREEN: 'FOUND_PASSWORD',
      },
    });
  }, [logAnalyticsEvent]);
};
